function formatDateWithMonth(date) {
    const dateObj = new Date(date);
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const day = dateObj.getDate();
    const monthIndex = dateObj.getMonth();

    return day + ' ' + monthNames[monthIndex];
}

export default formatDateWithMonth;